import { User, UserSettings } from '@xeetr/types/models'

import ApiService from './common/API.service'


export class UserService extends ApiService {
  getUser = async (): Promise<User> => {
    const { data } = await this.get<User>(this.buildCommonUrl('user'))
    return data
  }

  getUserSettings = async (): Promise<UserSettings> => {
    const { data } = await this.get<UserSettings>(this.buildCommonUrl('user/settings'))
    return data as UserSettings
  }

  patchUserSettings = async (settings: Partial<UserSettings>): Promise<UserSettings> => {
    const { data } = await this.patch<Partial<UserSettings>, UserSettings>(
      this.buildCommonUrl('user/settings'),
      settings
    )
    return data as UserSettings
  }
}
